import { GetIntegrationConnectUrlMutationVariables } from '@sketch/gql-types'

import Slack from '@sketch/icons/slack@1x.png'
import SlackRetina from '@sketch/icons/slack@2x.png'

export const INTEGRATION_INFO: Record<
  GetIntegrationConnectUrlMutationVariables['provider'],
  { name: string; about: string; icon: string; icon2x: string; website: string }
> = {
  SLACK: {
    name: 'Slack',
    about:
      'Connect Sketch directly with Slack to keep your team instantly informed and aligned. Stop chasing updates—get notified about the latest changes to designs and the creation of new design documents right in your preferred channel.',
    icon: Slack,
    icon2x: SlackRetina,
    website: 'https://slack.com',
  },
}
